<app-system-message></app-system-message>
<div [ngClass]="theme.getThemeClass()" class="container-fluid">
  <div class="page-header">
    <!-- For future development -->
    <!-- <button class="btn back" (click)="backToBinModelList()"><i class="fa fa-arrow-left"></i></button> -->
    <h2>{{"binListViewBinList" | translate}}</h2>
  </div>
  <nav
    id="search-component"
    class="nav-sort-filter"
  >
    <input
      #searchBox
      type="search"
      id="search-box"
      [(ngModel)]="userFilter"
      (input)="search()"
      class="form-control rounded searchInput"
      placeholder="{{ 'userlistSearchInputPlaceHolder' | translate }}"
      aria-label="Search"
      aria-describedby="search-addon"
    />
    <select
      class="form-control sort-by-select"
      [(ngModel)]="this.filterBy"
      [ngClass]="{ 'has-value': this.filterBy }"
    >
      <option value="">{{ 'filterBy' | translate }}</option>
      @for (option of filterOptions; track option.value) {
        <option [value]="option.value">{{ option.label | translate }}</option>
      }
    </select>
    <select
      class="form-control sort-by-select"
      [(ngModel)]="this.sortBy"
      (change)="onSortChange('select')"
      [ngClass]="{ 'has-value': this.sortBy }"
    >
      <option value="">{{ 'sortBy' | translate }}</option>
      @for (option of sortOptions; track option.value) {
        <option [value]="option.value">{{ option.label | translate }}</option>
      }
    </select>
    <div class="card-title mt-0 status">
      <label class="switch">
          <input type="checkbox" [ngModel]="this.ascDesc" (change)="onSortChange('switch')">
          <span class="slider round">
            <span class="toggle-switch-label-off">{{ "asc" | translate }}</span>
            <span class="toggle-switch-label-on">{{ "desc" | translate }}</span>
          </span>
      </label>
    </div>
  </nav>
  <div class="grid-container" [ngClass]="theme.getThemeClass()">
    <section [ngClass]="theme.getThemeClass()" class="gridster" [ngStyle]="{'grid-template-columns': getColumnStyle()}">
      @for (item of this.clientBinArray; track item.bin_id) {
        <article class="gridster-item">
          <!-- Your tile content goes here -->
          <nav [ngClass]="theme.getThemeClass()">
            <header class="dashboard-tile-header">
              <a class="dashboard-tile-name" [routerLink]="['/bin-update', item.bin_id]">
                <h6 class="dashboard-tile-title">{{ item.bin_name }}</h6>
              </a>
              @if (item.thing_name) {
              <div class="dashboard-tile-device">
                <i class="fa-solid fa-microchip  device-icon"></i>
                <label class="item-label device-label ">{{ item.thing_name }}</label>
              </div>
              }
            </header>
            <hr>
            <div class="tiles-container">
              <div class="titles-items">
                <i class="fa fa-trash tile-icon"></i>
                <label class="item-label">{{ item.bin_usage | translate }}</label>
              </div>
              <div class="titles-items">
                <i class="fa-solid fa-store tile-icon"></i>
                <label class="item-label">{{( item.market_segment | translate ) || "N/A" }}</label>
              </div>
              <div class="titles-items address-row">
                <i class="fa fa-map-marker tile-icon pointer"></i>
                <button
                  type="button"
                  class="address-trigger"
                  (click)="openAddressOverlay(item.bin_address)"
                >
                  <span class="item-label addressVisible">{{ item.bin_address || ("binNoAddress" | translate) }}</span>
                </button>
              </div>
            </div>
          </nav>
        </article>
      }
    </section>
  </div>
</div>

@if (selectedAddress) {
  <div class="address-overlay" (click)="closeAddressOverlay()">
    <div class="address-overlay-card" (click)="$event.stopPropagation()">
      <button type="button" class="address-overlay-close" (click)="closeAddressOverlay()">x</button>
      <p class="address-overlay-text">{{ selectedAddress }}</p>
    </div>
  </div>
}
